import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrincipalConfigurationService } from '../../../core/user';
import { prepareUrlForLink } from '../../../core/util';

@Injectable({ providedIn: 'root' })
export class CatalogGuard {
  constructor(protected router: Router, private principalConfigurationService: PrincipalConfigurationService) {}

  canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (!this.hasParam(route.queryParams, 'mya')) {
      return combineLatest([
        this.principalConfigurationService.isEnabled('enableTogglingOfCustomerAssortment'),
        this.principalConfigurationService.isEnabled('defaultCustomerAssortmentToggleState'),
      ]).pipe(
        map(([enableTogglingOfCustomerAssortment, defaultCustomerAssortmentToggleState]) => {
          if (enableTogglingOfCustomerAssortment) {
            const url = prepareUrlForLink(routerState.url, {
              mya: defaultCustomerAssortmentToggleState && !this.hasParam(route.queryParams, 'aou') ? '1' : '0',
            });
            return this.router.parseUrl(url);
          }
          return true;
        })
      );
    }
    return of(true);
  }

  private hasParam(queryParams: Params, param: string): boolean {
    return !!(queryParams && queryParams[param]);
  }
}
